/* =========================================================
   INKSOFT CORE MODULE
   Shared utilities across ALL pages
========================================================= */

window.InksoftPOC = window.InksoftPOC || {};

window.InksoftPOC.API_BASE =
  "https://shopify-inksoft-poc-node.azurewebsites.net/api/poc";

window.InksoftPOC.core = (function () {
  function log(...args) {
    console.log("[InksoftPOC]", ...args);
  }

  function error(...args) {
    console.error("[InksoftPOC]", ...args);
  }

  async function fetchJSON(url) {
    try {
      const res = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json"
        }
      });

      const rawText = await res.text();

      if (!res.ok) {
        throw new Error("HTTP " + res.status + " | " + rawText.slice(0, 300));
      }

      try {
        return JSON.parse(rawText);
      } catch (parseErr) {
        throw new Error(
          "Response was not valid JSON. First 300 chars: " + rawText.slice(0, 300)
        );
      }
    } catch (err) {
      error("fetchJSON error:", err, url);
      throw err;
    }
  }

  function qs(name) {
    const url = new URL(window.location.href);
    return url.searchParams.get(name);
  }

  function escapeHtml(str) {
    if (str === null || str === undefined) return "";

    return String(str).replace(/[&<>"']/g, function (m) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
      }[m];
    });
  }

  function uniqueBy(arr, key) {
    const seen = new Set();

    return (arr || []).filter(function (item) {
      const val = item && item[key];

      if (seen.has(val)) return false;

      seen.add(val);
      return true;
    });
  }

  function debounce(fn, delay = 200) {
    let t;

    return function (...args) {
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(null, args);
      }, delay);
    };
  }

  return {
    log,
    error,
    fetchJSON,
    qs,
    escapeHtml,
    uniqueBy,
    debounce
  };
})();